<template>
  <component
    :is="headerType"
    :id="headerId"
    :class="headerClass"
  >
    <slot>{{ headerContent }}</slot>
  </component>
</template>
<script>
export default {
  name: 'HeadlineComponent',
  props: {
    headerType: {
      type: String,
      default: 'h1',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    headerId: {
      type: String,
      default: 'headline',
    },

  },
};
</script>
<style lang="scss" scoped>
    h1#headline {
        margin:0 0 1em 0;
    }
</style>
